import Vue from 'vue'
import { Message, Notification, MessageBox, Checkbox, Alert,Select,Option,Input,Button,Loading   } from 'element-ui';
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;


// WEBPACK FOOTER //
// ./src/tool/element.js